<script>

import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Helper from '@/helpers/helper';
import { useExchangeStore } from '@/store/exchangeStore'
import { useCurrencyStore } from '@/store/currencyStore'

import { ref } from "vue";
import Swal from "sweetalert2";


/**
 * Dashboard Component
 */
export default {
    setup() {
        const doesAddOpen = ref(false);
        const doesEditOpen = ref(false);
        const doesDeleteOpen = ref(false);
        const doesLoadingOpen = ref(false);
        const exchangeStore = useExchangeStore();
        const currencyStore = useCurrencyStore();


        return {
          doesAddOpen,
          doesEditOpen,
          doesDeleteOpen,
          doesLoadingOpen,
          exchangeStore,
          currencyStore,
        };
    },
    page: {
    title: "exchange",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
    },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "exchange",
      items: [
        {
          text: "Menu",
        },
        {
          text: "exchange",
          active: true,
        },
      ],
      errors: [],
      exchange: {},
      exchanges: [],
      currencies: [],
      rate: "",
      fixed: 0,
      from_id: "",
      to_id: "",
      status: true,
      loading: false,
      statusHttp: 201,
      length: 0,
    };
  },
  methods: {
    toDate(date) {
      return Helper.toDate(date) 
    },
   


   async loadCurrencies() {
      if (!this.currencyStore.list) {
       await  this.currencyStore.loadFromApi().then(data => {
        this.currencies = data
      })
      } else {
        this.currencies = this.currencyStore.list
      }
  },



     
  async loadFromStore() {

      if (!this.exchangeStore.list) {
       await  this.exchangeStore.loadFromApi(true).then(data => {
        this.exchanges = data
        this.exchange_search = data;
        this.length = this.exchanges.length;
    })
      } else {
        this.exchanges = this.exchangeStore.list
        this.exchange_search = this.exchanges;
                this.length = this.exchanges.length;

      }

  },

 async refresh(){
  await  this.exchangeStore.loadFromApi(true).then(data => {
        this.exchanges = data
        this.exchange_search = data;
        this.length = this.exchanges.length;
    })
  },




    addItem() {
      this.errors = [];
      let body = {
        "from": {
          "id": this.from_id
        },
        "to": {
          "id": this.to_id
        },
        "rate": parseFloat(this.rate),
        "fixed": parseFloat(this.fixed),
        "status": this.status
      }

      if (this.type !== "") {
        body['type'] =  this.type
      }
      this.exchangeStore.createItem(body);
      this.exchanges = this.exchangeStore.list
      this.exchange_search = this.exchanges

    },

    editItem() {
      this.errors = [];
      let body = {
        "from": {
          "id": this.from_id
        },
        "to": {
          "id": this.to_id
        },
        "rate": parseFloat(this.rate),
        "fixed": parseFloat(this.fixed),
        "status": this.status
      }

      this.exchangeStore.editItem(this.exchange?.id, body);
      this.exchanges = this.exchangeStore.list
      this.exchange_search = this.exchanges

     
    },

     deleteIt() {
      this.exchangeStore.deleteItem(this.exchange.id);
      this.exchanges = this.exchangeStore.list
      this.exchange_search = this.exchanges
    },


   async onAddItem(){
      Swal.showLoading();
      await this.loadCurrencies();
      Swal.close();
      this.doesAddOpen =true;
    },

      compileToClipboard(text) {
      navigator.clipboard.writeText(text).then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal?.stopTimer;
            toast.onmouseleave = Swal?.resumeTimer;
          },
        });
        Toast.fire({
          icon: "success",
          title: "Le texte a été copié dans le presse-papier.",
        });
      });
    },



  async  initItem(exchange, action="edit") {
      this.exchange = exchange
      this.initData(exchange)
      if (action == "delete") {
        this.doesDeleteOpen = true
      } else {
        Swal.showLoading();
        await this.loadCurrencies();
        Swal.close();
        this.doesEditOpen = true
      }
    },

    initData(item = null) {
      this.rate = item != null ? item.rate : ""
      this.to_id = item != null ? item?.to?.id : ""
      this.from_id = item != null ? item?.from?.id : ""
      this.status = item != null ? item.status : true
    }
  },
  mounted() {
    this.loadFromStore()
    this.doesLoadingOpen = false
  },
  watch: {
    doesAddOpen: function() {
      this.errors = []
      if (!this.doesAddOpen) {
        this.initData(null)
      }
    },
    doesEditOpen: function() {
      this.errors = []
      if (!this.doesEditOpen) {
        this.initData(null)
        this.exchange = null
      }
    },
    doesDeleteOpen: function() {
      if (!this.doesDeleteOpen) {
        this.initData(null)
        this.exchange = null
      }
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    
    

    <div class="hstack mb-3" v-show="status != 403">
       <b-button variant="primary" @click="refresh()" class="ms-auto">
        <i class=" bx bx-refresh font-size-16 align-middle me-2"></i>
        Refresh
      </b-button>
        <b-button variant="primary" @click="onAddItem()" class="ms-1">
            <i class="bx bx-plus font-size-16 align-middle me-2"></i>
            Ajouter un nouveau
        </b-button>
    </div>
    
    <div class="row" v-show="status != 403">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listes des échanges</h4>
            <p class="card-title-desc">
              Le tableau ci-dessous présente la listes des <code>échanges</code>.
            </p>

            <div class="table-responsive">
              <table class="table align-middle mb-0">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>From</th>
                    <th>To</th>
                    <th>Rate</th>
                    <th>Fixed</th>
                    <th>Current</th>
                    <th>Variation</th>
                    <th>Status</th>
                    <th>Update</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(exchange, i) in exchanges" :key="exchange.id">
                    <th scope="row"  v-on:click="compileToClipboard(exchange.id)"
                      style="cursor: pointer">{{ i + 1 }}</th>
                    <td>
                      {{ exchange?.from?.isoCode }}
                      <span v-show="exchange?.from?.isoCode !== null">({{ exchange?.from?.symbol }})</span>
                    </td>
                    <td>
                      {{ exchange?.to?.isoCode }}
                      <span v-show="exchange?.to?.isoCode !== null">({{ exchange?.to?.symbol }})</span>
                    </td>
                    <td>{{ Number(exchange.rate) }}</td>
                    <td>{{ Number(exchange.fixed) }}</td>
                    <td>{{ Number(exchange.current) }}</td>
                    <td>{{ Number(exchange.min) }}/{{ Number(exchange.max) }}</td>
                    <td>{{ exchange.status ? "Oui" : "Non" }}</td>
                    <td>{{ toDate(exchange.lastUpdate) }}</td>
                    <td class="hstack">
                        <b-button class="btn-sm ms-2" @click="initItem(exchange, 'edit')" variant="success">
                            <i class="bx bx-edit font-size-16 align-middle mx-1"></i>
                        </b-button>
                        <b-button variant="danger" @click="initItem(exchange, 'delete')" class="ms-2 btn-sm">
                          <i class="bx bx-trash font-size-16 align-middle mx-1"></i>
                        </b-button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            
          </div>
        </div>
      </div>
    </div>

    
    

    <div v-show="status === 403">
      <h3 class="text-danger text-center my-5">Réserver à l'administrateur principal</h3>
    </div>

    <!-- LOADING MODAL -->
    <b-modal v-model="doesLoadingOpen" id="modal-center" centered size="md" title="Chargement..."
      title-class="font-18" hide-footer>
      <div class="text-center">
        <div class="spinner-border text-primary-" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </b-modal>

    <!-- ADD MODAL -->
    <b-modal
        v-model="doesAddOpen"
        id="modal-center"
        centered
        size="md"
        title="Ajouter un échange"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="addItem()">
          <div class="row">
            
            <div class="col-md-12 mb-3">
                <label for="">Currency From</label>
                <select required v-model="from_id" class="form-control">
                    <option value=""></option>
                    <template v-for="from in currencies" :key="from.id">
                      <option :value="from.id">{{ from.isoCode }}</option>
                    </template>
                </select>
            </div>
            <div class="col-md-12 mb-3">
                <label for="">Currency To</label>
                <select required :disabled="from_id == ''" v-model="to_id" class="form-control">
                    <option value=""></option>
                    <template v-for="to in currencies" :key="to.id">
                      <option v-if="to.id != from_id" :value="to.id">{{ to.isoCode }}</option>
                    </template>
                </select>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Rate </label>
              <input type="text" min="0" required v-model="rate" class="form-control">
              <span class="text-danger mt-2" v-if="errors.rate">{{ errors.rate }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Fixed </label>
              <input type="text" min="0" required v-model="fixed" class="form-control">
              <span class="text-danger mt-2" v-if="errors.fixed">{{ errors.fixed }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Status </label>
              <select class="form-control" required v-model="status">
                <option :value="true">Oui</option>
                <option :value="false">Non</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.status">{{ errors.status }}</span>
            </div>
            
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- EDIT MODAL -->
    <b-modal
        v-model="doesEditOpen"
        id="modal-center"
        centered
        size="md"
        title="Modifier un échange"
        title-class="font-18"
        hide-footer
        >
        <form @submit.prevent="editItem()">
          <div class="row">

            <div class="col-md-12 mb-3">
                <label for="">Currency From</label>
                <select required v-model="from_id" class="form-control">
                    <option value=""></option>
                    <template v-for="from in currencies" :key="from.id">
                      <option :value="from.id">{{ from.isoCode }}</option>
                    </template>
                </select>
            </div>
            <div class="col-md-12 mb-3">
                <label for="">Currency To</label>
                <select required :disabled="from_id == ''" v-model="to_id" class="form-control">
                    <option value=""></option>
                    <template v-for="to in currencies" :key="to.id">
                      <option v-if="to.id != from_id" :value="to.id">{{ to.isoCode }}</option>
                    </template>
                </select>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Rate </label>
              <input type="text" min="0" required v-model="rate" class="form-control">
              <span class="text-danger mt-2" v-if="errors.rate">{{ errors.rate }}</span>
            </div>
             <div class="col-md-12 mb-3">
              <label for="">Fixed </label>
              <input type="text" min="0" required v-model="fixed" class="form-control">
              <span class="text-danger mt-2" v-if="errors.fixed">{{ errors.fixed }}</span>
            </div>
            <div class="col-md-12 mb-3">
              <label for="">Status </label>
              <select class="form-control" required v-model="status">
                <option value="">Status</option>
                <option :value="true">Oui</option>
                <option :value="false">Non</option>
              </select>
              <span class="text-danger mt-2" v-if="errors.status">{{ errors.status }}</span>
            </div>
        
          </div>
          <div class="mt-3" v-if="!loading">
            <input type="submit" value="Enregistrer" class="btn btn-primary">
          </div>
          <div class="mt-3 text-center" v-else>
            <div class="spinner-border text-primary" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </form>
    </b-modal>


    <!-- DELETE MODAL -->
    <b-modal
        v-model="doesDeleteOpen"
        id="modal-center"
        title="Supprimer un échange"
        title-class="font-18"
        hide-footer
        >
        <p class="mb-2">
            Voulez-vous vraiment supprimer l'échange <b>{{ exchange?.from?.name }} - {{ exchange?.to?.name }}</b> ?
        </p>
        <div class="hstack mt-2" v-if="!loading">
          <button class="btn btn-dark ms-auto" @click="doesDeleteOpen = false">Annuler</button>
          <button class="ms-3 btn btn-danger" @click="deleteIt()">Supprimer</button>
        </div>
        <div class="text-center" v-else>
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
    </b-modal>


  </Layout>
</template>
